import { accountsAdapter, AccountState } from "./account.entity";
import { createReducer, on, Action } from "@ngrx/store";
import { accountsActionTypes } from "./account.actions";
import { authActionTypes } from "../../../auth/store/auth.actions";

export const initialState: AccountState = accountsAdapter.getInitialState({
    ids: [],
    total: 0,
    loaded: false,

    paginationMetaData: null,
    searchString: null,
    error: null
});

export const accountsReducerObj = createReducer(
    initialState,

    on(accountsActionTypes.setAccountsAction, (state, action) => {

        if ( action.accounts && action.accounts.Accounts !== null && action.accounts.Accounts.length > 0 ) {
            return accountsAdapter.addAll(action.accounts.Accounts, {
                ...state,
                paginationMetaData: action.accounts.PaginationMetaData,
                searchString: action.searchString,
                loaded: true,
                total: action.accounts.PaginationMetaData.TotalCount,
            });
        } else {
            return accountsAdapter.removeAll(state);
        }
    }),

    on(accountsActionTypes.setAccountsActionFail, (state, action) => {
            return {
            ...state,
            error: action.error
        }
    }),

    on(accountsActionTypes.clearAccountSearchStringAction, (state, action) => ({
        ...state,
        searchString: ''
    })),

    on(accountsActionTypes.clearAccountsAction, (state, action) => {
        return accountsAdapter.removeAll(state);
    }),

    on(authActionTypes.LogOut, (state, action) => {
        return accountsAdapter.removeAll({
            ...state,
            loaded: false,
            total: 0,
        });
    }),
);

export function reducer(
    state: AccountState = initialState,
    action: Action
): AccountState {
    return accountsReducerObj(state, action);
}

export const accountsSelectors = accountsAdapter.getSelectors();
